import { faCheck, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/components/Typography';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface Language {
  code: string;
  labelKey: string;
  flag: string;
}

const languages: Language[] = [
  { code: 'en', labelKey: 'user.menu.language_en', flag: '🇬🇧' },
  { code: 'fr', labelKey: 'user.menu.language_fr', flag: '🇫🇷' },
];

/** Sélecteur de langue de l'en-tête (drapeau + code de la langue courante). */
export const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[1];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id='language-switcher-button'
          variant='ghost'
          size='sm'
          aria-label={t('user.menu.language')}
        >
          <span aria-hidden='true'>{currentLanguage.flag}</span>
          {currentLanguage.code.toUpperCase()}
          <FontAwesomeIcon icon={faChevronDown} className='size-3' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        {languages.map((language) => (
          <DropdownMenuItem
            id={`language-option-${language.code}`}
            key={language.code}
            onSelect={() => i18n.changeLanguage(language.code)}
          >
            <span aria-hidden='true'>{language.flag}</span>
            <Typography as='span' variant='paragraphSmall' color='foreground' className='flex-1'>
              {t(language.labelKey)}
            </Typography>
            {language.code === currentLanguage.code ? <FontAwesomeIcon icon={faCheck} /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
